import { deviceOrder } from './Devices'

const tooltipchem = 'Na, K, Cl, iCa, Glu, BUN/Urea, TCO2, Crea, Hct, AnGap, Hb'
const tooltipcg4 = 'pH, PCO2, PO2, Lac, HCO3, TCO2, BE, sO2'

export const Orders = [
  { label: 'CHEM8+', value: 'CHEM8+', title: tooltipchem, kind: deviceOrder.kind },
  { label: 'CG4+', value: 'CG4+', title: tooltipcg4, kind: deviceOrder.kind },
  { label: 'ACTk', value: 'ACTk', kind: deviceOrder.kind },
  { label: 'ACTc', value: 'ACTc', kind: deviceOrder.kind },
  { label: 'PT/INR', value: 'PT/INR', kind: deviceOrder.kind },
  { label: 'cTnl', value: 'cTnl', kind: deviceOrder.kind },
  { label: 'CK-MB', value: 'CK-MB', kind: deviceOrder.kind },
  { label: 'BNP', value: 'BNP', kind: deviceOrder.kind },
  { label: 'Urine test strip', value: 'Urine test strip', kind: deviceOrder.kind },
  { label: 'Urine culture', value: 'Urine culture', kind: deviceOrder.kind },
  // { label: 'COVID-19', value: 'COVID-19', kind: deviceOrder.kind },
  // { label: 'Strep', value: 'Strep', kind: deviceOrder.kind },
  { label: 'Custom', value: 'custom', kind: deviceOrder.kind },
]
